// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.icon-button_285fa73f {
  margin: 0;
  padding: 0;
  border: 0;
}
.icon-button_285fa73f {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  background: none;
  color: #657682;
}
.icon-button_285fa73f:hover {
  text-decoration: none;
  color: #26649e;
}
.icon-button_285fa73f:active {
  color: #11304d;
}
.icon-button_285fa73f:disabled {
  cursor: default;
  background-color: transparent !important;
  color: #c1c8cd !important;
}
.icon-button_button_285fa73f {
  color: #1d5080;
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
}
.icon-button_button_285fa73f.icon-button_size-l_285fa73f {
  width: 2rem;
  min-width: 2rem;
  height: 2rem;
}
.icon-button_button_285fa73f.icon-button_size-xl_285fa73f {
  width: 2.667rem;
  min-width: 2.667rem;
  height: 2.667rem;
}
.icon-button_button_285fa73f:hover {
  color: #267479;
}
.icon-button_button_285fa73f:hover:not(.icon-button_flat_285fa73f) {
  background-color: #eaedef;
}
.icon-button_button_285fa73f:active {
  color: #1d5080;
}
.icon-button_button_285fa73f:active:not(.icon-button_flat_285fa73f) {
  background-color: #dce1e5;
}
.icon-button_button_285fa73f.icon-button_selected_285fa73f {
  background-color: #dce1e5;
}
.icon-button_button_285fa73f.icon-button_selected_285fa73f:hover {
  background-color: #dce1e5;
  color: #1d5080;
}
.icon-button_button_285fa73f.icon-button_selected_285fa73f:disabled {
  background-color: #eaedef !important;
  color: #c1c8cd !important;
}
.icon-button_inline_285fa73f {
  display: inline-flex;
}
.icon-button__hole_285fa73f {
  display: block;
  position: relative;
  left: 0;
  right: 0;
  margin: auto;
}
.icon-button_with-loader_285fa73f {
  position: relative;
}
.icon-button_with-loader_285fa73f .icon-button__hole_285fa73f > i {
  opacity: 0;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"icon-button": `icon-button_285fa73f`,
	"icon-button_button": `icon-button_button_285fa73f`,
	"icon-button_size-l": `icon-button_size-l_285fa73f`,
	"icon-button_size-xl": `icon-button_size-xl_285fa73f`,
	"icon-button_flat": `icon-button_flat_285fa73f`,
	"icon-button_selected": `icon-button_selected_285fa73f`,
	"icon-button_inline": `icon-button_inline_285fa73f`,
	"icon-button__hole": `icon-button__hole_285fa73f`,
	"icon-button_with-loader": `icon-button_with-loader_285fa73f`
};
export default ___CSS_LOADER_EXPORT___;
